/**
 * Generates a room ID in xxx-xxx-xxx format
 * Uses alphanumeric characters for readability
 */
export const generateRoomId = (): string => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  const part = () =>
    Array.from({length: 3}, () => chars[Math.floor(Math.random() * chars.length)]).join('')
  return `${part()}-${part()}-${part()}`
}
